import { EntityModel } from '@/interfaces'
import {
  ALL_PARTNER_TENANTS_QUERY,
  CREATE_PARTNER_TENANT_MUTATION,
  DELETE_PARTNER_TENANT_MUTATION,
  FORCE_DELETE_PARTNER_TENANT_MUTATION,
  SINGLE_PARTNER_TENANT_QUERY,
  UPDATE_PARTNER_TENANT_MUTATION,
} from './graphql'
import tenantEntity from '@/entities/tenant/entity'

const partnerTenantModel: EntityModel = {
  name: 'partnerTenant',
  namePlural: 'partnerTenants',
  uniqueName: 'partnerTenant',
  uniqueNamePlural: 'partnerTenants',
  path: 'config/tenant/partner_tenant',
  baseUrl: '/config/tenant/partner_tenants',
  translationPrefix: 'entities:partnerTenant.',
  getDisplayName: (values: any) => {
    return ''
  },
  gql: {
    getAll: ALL_PARTNER_TENANTS_QUERY,
    getSingle: SINGLE_PARTNER_TENANT_QUERY,
    create: CREATE_PARTNER_TENANT_MUTATION,
    update: UPDATE_PARTNER_TENANT_MUTATION,
    delete: DELETE_PARTNER_TENANT_MUTATION,
    forceDelete: FORCE_DELETE_PARTNER_TENANT_MUTATION,
  },
  attributes: {
    tenant: {
      name: 'tenant',
      label: 'entities:partnerTenant.attributes.tenant.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return tenantEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    filterCrossLinking: {
      name: 'filterCrossLinking',
      label: 'entities:partnerTenant.attributes.filterCrossLinking.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
  },
}

export default partnerTenantModel
